/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_FlexInputs */

const en_mk_cmp_r_flex = /** @type {(inputs: Mk_Cmp_R_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freedom to build your own structure`)
};

const id_mk_cmp_r_flex = /** @type {(inputs: Mk_Cmp_R_FlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keleluasaan menyusun sendiri`)
};

/**
* | output |
* | --- |
* | "Freedom to build your own structure" |
*
* @param {Mk_Cmp_R_FlexInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_flex = /** @type {((inputs?: Mk_Cmp_R_FlexInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_FlexInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_flex(inputs)
	return en_mk_cmp_r_flex(inputs)
});